import { setWorkerUrl } from "maplibre-gl";
import maplibreWorkerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";

/**
 * MapLibre 6 calcule l'URL de son worker à l'exécution, à partir de l'URL du
 * module courant (`new URL("./maplibre-gl-worker.mjs", import.meta.url)`).
 * Aucun bundler ne peut le voir statiquement : une fois l'application
 * empaquetée, le worker est cherché à côté du bundle et n'y est pas.
 *
 * Le symptôme est silencieux et coûteux à diagnostiquer : la carte s'affiche,
 * aucune erreur n'apparaît en console, mais les sources GeoJSON sont traitées
 * dans le worker — donc aucune pastille ne se dessine jamais.
 *
 * On désigne donc explicitement le worker, que Vite empaquette et versionne
 * comme n'importe quel autre asset. Importer ce module avant de construire une
 * carte suffit.
 */
setWorkerUrl(maplibreWorkerUrl);
